import React, { useCallback, useContext, useEffect, useState } from 'react';

import { LangService }             from '../services';
import { ProjectContext }          from '../views/pages/projects/ProjectIndexPage';
import { DEFAULT_TERM_DICTIONARY } from '../lang/termDictionaries';
import { ITermDictionary }         from '../lang/LangTypes';

// Usages:
// console.log( getTerm( 'PROJECT_MILESTONES.LAUNCHDATE.LABEL' ) );
// console.log( getTerm( ['PROJECT_MILESTONES','LAUNCHDATE','LABEL'] ) );
// console.log( termDictionary.PROJECT_MILESTONES.LAUNCHDATE.LABEL );
interface ProjectTermDictionaryHook {
	
	// The current term dictionary for this project
	termDictionary: ITermDictionary,
	
	// Method to retrieve a term
	getTerm( termPath: string | string[] ): string
}

export const useProjectTermDictionary = (): ProjectTermDictionaryHook => {
	
	let { projectId, projectDictionary }            = useContext( ProjectContext ),
	    [ currentDictionary, setCurrentDictionary ] = useState( DEFAULT_TERM_DICTIONARY );
	
	useEffect( () => {
		
		if( projectDictionary ){
			
			const newDictionary = LangService.mergeDictionaries( DEFAULT_TERM_DICTIONARY, projectDictionary );
			
			setCurrentDictionary( newDictionary );
		}
		
	}, [ projectId, projectDictionary ] );
	
	const getTerm = useCallback<ProjectTermDictionaryHook['getTerm']>( ( path ) => {
		
		return LangService.getTermFromDictionary( path, currentDictionary );
		
	}, [ currentDictionary ] );
	
	return {
		termDictionary: currentDictionary,
		getTerm
	};
};
